import React, {useEffect, Suspense} from "react";
import {Routes, Route, Redirect, useNavigate, Navigate, BrowserRouter} from 'react-router-dom';
import {useLocation} from "react-router";
import {M2_getQuoteId, API_ENDPOINT} from "../components/Tools/API_GetOption";

// Lazy-loaded pages — webpack splits these into separate chunks
// VHome + Tools.js will be its own ~1MB chunk instead of blocking initial load
const VHome = React.lazy(() => import("../views/Home/VHome"));
const _404 = React.lazy(() => import('../views/404/index'));

function useQuery() {
    const {search} = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
    /*
    if (location.protocol !== "https:") {
       location.replace(window.location.href.replace("http:", "https:"));
    }
     */
}

const Router = () => {
    const query = useQuery()
    let quote_id = query.get('q') ?? null
    const rawId = query.get('id')
    const item_id = rawId ? parseInt(rawId, 10) || null : null
    const pathName = window.location.pathname
    const pathNameCleaned = pathName.replace(/\//g, '');
    // Build a clean base URL without any query params (_gl, _ga, etc.)
    const cleanUrl = `${window.location.origin}${pathName}`;
    if (pathNameCleaned === 'byops5' || pathNameCleaned === 'build-your-own-ps4' || pathNameCleaned === 'byoxbx' || pathNameCleaned === 'buildyourownELITExb1' || pathNameCleaned === 'byops5led' || pathNameCleaned === 'byoxbxled')
    {
        if (!quote_id)
        {
            window.location.href = `${API_ENDPOINT()}/modz/cart/index?redirect=${encodeURIComponent(cleanUrl)}`
            return
        }
        else if (quote_id === 'new')
        {
            (async() => {
                quote_id = await M2_getQuoteId()
                window.location.href = `${cleanUrl}?q=${quote_id}`
            })()
            return
        }
    }

    return (
        <Suspense fallback={
            <div style={{display:'flex',alignItems:'center',justifyContent:'center',height:'100vh',background:'#0a0a0a'}}>
                <img
                    src={require('../assets/images/logo-icon-dark.png')}
                    alt="Loading"
                    style={{width:80,animation:'cm-pulse 1.5s ease-in-out infinite'}}
                />
            </div>
        }>
        <Routes>
            <Route path='/' element={<VHome selectedController={{
                title: 'Build Your Own Playstation 5 Controller',
                id: 'byops5',
                quote_id,
                item_id,
                iniPrice: 69.99
            }}/>}/>
            <Route path='/byops5' element={<VHome selectedController={{
                title: 'Build Your Own Playstation 5 Controller',
                id: 'byops5',
                quote_id,
                item_id,
                iniPrice: 69.99
            }}/>}/>
            <Route path='/build-your-own-ps4' element={<VHome selectedController={{
                title: 'Build Your Own Playstation 4 Controller',
                id: 'build-your-own-ps4',
                quote_id,
                item_id,
                iniPrice: 69.99
            }}/>}/>
            <Route path='/byoxbx' element={<VHome selectedController={{
                title: 'Build Your Own Xbox Controller',
                desc: '- Compatible with all Xbox One & Series S+X Consoles ',
                id: 'byoxbx',
                quote_id,
                item_id,
                iniPrice: 69.99
            }}/>}/>
            <Route path='/buildyourownELITExb1' element={<VHome selectedController={{
                title: 'Build Your Own Xbox ELITE Controller',
                id: 'buildyourownELITExb1',
                quote_id,
                item_id,
                iniPrice: 169.99
            }}/>}/>

            <Route path='/byops5led' element={<VHome selectedController={{
                title: 'Build Your Own PS5 LED Controller',
                id: 'byops5led',
                quote_id,
                item_id,
                iniPrice: 99.99
            }}/>}/>

            <Route path='/byoxbxled' element={<VHome selectedController={{
                title: 'Build Your Own Xbox LED Controller',
                id: 'byoxbxled',
                desc: '- Compatible with all Xbox One & Series S+X Consoles ',
                quote_id,
                item_id,
                iniPrice: 104.99
            }}/>}/>
            <Route path='/404' element={<_404/>}/>
            <Route path='*' element={<Navigate to="/404"/>}/>
        </Routes>
        </Suspense>
    )
}

export default Router;
